/* Catalan translation for the jQuery Timepicker Addon */
/* Written by Sergi Faber */
(function($) {
	$.timepicker.regional['ca'] = {
		timeOnlyTitle: 'Escollir una hora',
		timeText: 'Hora',
		hourText: 'Hores',
		minuteText: 'Minuts',
		secondText: 'Segons',
		millisecText: 'Milisegons',
		microsecText: 'Microsegons',
		timezoneText: 'Fus horari',
		currentText: 'Ara',
		closeText: 'Tancar',
		timeFormat: 'HH:mm',
		timeSuffix: '',
		amNames: ['AM', 'A'],
		pmNames: ['PM', 'P'],
		isRTL: false
	};
	$.timepicker.setDefaults($.timepicker.regional['ca']);
})(jQuery);
